<template>
  <div v-if="mode">
    <h5 class="md-toolbar-section-start">{{saveData.label | token_replace(nid)}}</h5>
    <comment :element-uuid="element.uuid" :submission-uuid="main_sid" />
    <md-field v-if="!this.valid" :class="messageClass" class="label-top">
      <span class="md-error">*Required.</span>
    </md-field>
    <div class="scorm-iframe-wrapper">
      <spinner v-if="!iframeUrl || !ready"></spinner>
      <iframe v-show="saveData.value && saveData.value.id && iframeUrl"
        @load="iframeLoad"
        :id="'scorm-iframe-' + saveData.value.id"
        class="scorm-iframe"
        :data-content-id="saveData.value.id"
        frameborder="0"
        scrolling="no"
        :src="iframeUrl"
        ref="iframe"
        :title="saveData.label != '' ? saveData.label : saveData.node_name"
      ></iframe>
    </div>
  </div>
  <md-card v-else class="md-elevation-2 md-layout-item">
    <fb-controll
      :controll="saveData.label || 'SCORM'"
      @collapse-click="collapsePreview"
      @setting-click="showSettings"
      @menu-delete="$emit('menu-delete')"
    />
    <md-content v-show="!collapse">
      <h2>SCORM: {{saveData.node_name | token_replace(nid, 'scorm')}}</h2>
    </md-content>
    <md-dialog :md-active.sync="showDialog" md-dynamic-height>
      <md-dialog-title>Settings</md-dialog-title>
      <md-dialog-content>
        <md-field>
          <label>Label</label>
          <md-input v-model="tempData.label"></md-input>
        </md-field>
        <md-autocomplete
          :value="tempData.node_name"
          md-value-key="value"
          :md-options="node_list"
          @md-changed="getNodes"
          @md-opened="getNodes"
          @md-selected="setScorm"
        >
          <label>Scorm Content</label>
          <template slot="md-autocomplete-item" slot-scope="{ item }">{{ item.name }}</template>
        </md-autocomplete>
        <md-checkbox v-model="tempData.required">Required</md-checkbox><br/>
        <md-checkbox v-model="tempData.include_submission">Include on submission view and download</md-checkbox>
        <md-field>
          <label>Height Options</label>
        </md-field>
        <md-radio v-model="tempData.custom_height_checkbox" value="16:9">16:9</md-radio><br/>
        <md-radio v-model="tempData.custom_height_checkbox" value="custom">Custom</md-radio><br/>
        <div v-if="tempData.custom_height_checkbox">
          <md-field v-if="tempData.custom_height_checkbox == 'custom'">
            <label>Custom height</label>
            <md-input v-model="tempData.custom_height"></md-input>
          </md-field>
        </div>
        <p><a target="_blank" href="/node/add/scorm">Create SCORM</a></p>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="cancel">Close</md-button>
        <md-button class="md-primary" @click="save">Save</md-button>
      </md-dialog-actions>
    </md-dialog>
  </md-card>
</template>

<script>
import FbElementMixin from "../FbElementMixin";
import Spinner from "../../Spinner.vue";
import HelpersMixin from '../../../HelpersMixin';

export default {
  name: "FbScorm",
  props: ["element", "mode", "validate", "step", "active"],
  mixins: [FbElementMixin, HelpersMixin],
  created() {
    if (
      this.sid &&
      this.sid != "" &&
      window.drupalSettings.form_builder[this.nid]["submissions"][this.sid][
        this.element.uuid
      ]
    ) {
      this.saveData.result =
        window.drupalSettings.form_builder[this.nid]["submissions"][this.sid][
          this.element.uuid
        ].value;
      this.$emit("set-value", this.value);
    }
    this.$emit("validation", this.valid);
  },
  computed: {
    messageClass() {
      return {
        "md-invalid": !this.valid && this.validate === true
      };
    },
    valid() {
      if (this.isDraft) {
        return true;
      }
      if (
        (this.saveData.required === false && this.step == this.active) ||
        (this.saveData.required === false && this.viewed)
      ) {
        return true;
      }
      if (this.saveData.required === false) {
        return true;
      }
      return (
        this.saveData.required === true &&
        (
          this.saveData.result['cmi.completion_status'] &&
          (
            this.saveData.result['cmi.completion_status'] === 'completed' ||
            this.saveData.result['cmi.completion_status'] === 'passed'
          )
          ||
          this.saveData.result['cmi.core.lesson_status'] &&
          (
            this.saveData.result['cmi.core.lesson_status'] === 'completed' ||
            this.saveData.result['cmi.core.lesson_status'] === 'passed'
          )
        )
      );
    },
    value() {
      if (this.valid) {
        return {
          uuid: this.element.uuid,
          label: this.saveData.label,
          value: this.saveData.result,
          type: this.element.type
        };
      }
      return undefined;
    }
  },
  mounted: function() {
    this.init();
  },
  activated: function() {
    this.init();
  },
  data() {
    return {
      node_list_ext: [],
      node_list: [],
      result_list: [],
      iframeUrl: null,
      ready: false,
      viewed: false,
      vid: null,
      pass_rate: null,
      tempData: {
        node_name:
          this.element && this.element.data ? this.element.data.node_name : "",
        label: this.element && this.element.data ? this.element.data.label : "",
        value: this.element && this.element.data ? this.element.data.value : {},
        result: {},
        custom_height_checkbox: this.element && this.element.data
            ? this.element.data.custom_height_checkbox
            : '16:9',
        custom_height: this.element && this.element.data
            ? this.element.data.custom_height
            : '',
        required:
          this.element && this.element.data
            ? !!this.element.data.required
            : false,
        include_submission:
          this.element && this.element.data
            ? !!this.element.data.include_submission
            : false
      },
      saveData: {
        node_name:
          this.element && this.element.data ? this.element.data.node_name : "",
        label: this.element && this.element.data ? this.element.data.label : "",
        value: this.element && this.element.data ? this.element.data.value : {},
        result: {},
        custom_height_checkbox: this.element && this.element.data
            ? this.element.data.custom_height_checkbox
            : '16:9',
        custom_height: this.element && this.element.data
            ? this.element.data.custom_height
            : '',
        required:
          this.element && this.element.data
            ? !!this.element.data.required
            : false,
        include_submission:
          this.element && this.element.data
            ? !!this.element.data.include_submission
            : false
      }
    };
  },
  methods: {
    init() {
      let nid = this.saveData.value.id;
      this.getScormResults().then(res=>{
        this.scoId = res.id;
        this.updateScormResults(res.data);
        if (nid) {
          let scormUrl = '/api/scorm/' + nid;
          if (this.$el.closest('.md-stepper-content') && this.active == this.step) {
            this.iframeUrl = scormUrl;
            // this.ready = true;
          }
          else if (!this.$el.closest('.md-stepper-content')) {
            // not in any stepper so load as is
            this.iframeUrl = scormUrl;
          }
        }
      });
    },
    updateScormResults(data) {
      function flattenObject(ob) {
        var toReturn = {};

        for (var i in ob) {
          if (!ob.hasOwnProperty(i)) continue;

          if ((typeof ob[i]) == 'object' && ob[i] !== null) {
            var flatObject = flattenObject(ob[i]);
            for (var x in flatObject) {
              if (!flatObject.hasOwnProperty(x)) continue;

              toReturn[i + '.' + x] = flatObject[x];
            }
          } else {
            toReturn[i] = ob[i];
          }
        }
        return toReturn;
      }
      if (data) {
        this.saveData.result = flattenObject(data);
      }
      this.$emit("validation", this.valid);
      this.$emit("set-value", this.value);
    },
    getScorm() {
    },
    getScormResults() {
      let nodeId = this.saveData.value.id;
      let scormUrl = '/api/scorm/' + nodeId + '/results';
      return fetch(scormUrl)
        .then(res => {
          return res.json();
        })
        .then(json => {
          return json;
        });
    },
    getNodes(searchTitle) {
      this.node_list = new Promise(resolve => {
        if (!searchTitle) {
          resolve(this.node_list_ext);
          return;
        }
        const node = searchTitle.toLowerCase();
        const content_manager_groups = drupalSettings.user.content_manager_groups;

        let requestUri = "/jsonapi/node/scorm?filter[title][condition][path]=title&filter[title][condition][value]=" +
          node +
          "&filter[title][condition][operator]=CONTAINS";
        if (this.isAdministrator() != true) {
          if (content_manager_groups && Object.keys(content_manager_groups).length) {
            requestUri += '&filter[field_group_user][group][conjunction]=OR';
            requestUri += '&filter[field_group][condition][path]=field_group.id&';
            Object.keys(content_manager_groups).forEach((value, index) => {
              requestUri += '&filter[field_group][condition][value][' +index +']=' + value;
            });
            requestUri += '&filter[field_group][condition][operator]=IN';
            requestUri += '&filter[field_group][condition][memberOf]=field_group_user';
            requestUri += "&filter[uid][condition][path]=uid.id";
            requestUri += "&filter[uid][condition][value]=" + window.drupalSettings.user.uuid;
            requestUri += "&filter[uid][condition][memberOf]=field_group_user";
          }
          else {
            requestUri += "&filter[uid.id][value]=" + window.drupalSettings.user.uuid;
          }
        }

        fetch(requestUri)
          .then(res => {
            return res.json();
          })
          .then(json => {
            let res = json.data.map(el => {
              return {
                id: el.attributes.drupal_internal__nid,
                name: el.attributes.title
              };
            });
            let filtered = res.filter(({ name }) => {
              return name.toLowerCase().includes(node);
            });
            this.node_list_ext = filtered;
            resolve(filtered);
          })
          .catch(() => {
            resolve(this.node_list_ext);
          });
      });
    },
    setScorm(event) {
      this.tempData.node_name = event.name;
      this.tempData.value = event;
    },
    updateScorm(node) {
      this.saveData.value = node;
      this.$emit("validation", this.valid);
    },
    iframeLoad() {
      this.initIframeEvents();
      // this.ready = true;
    },
    initIframeEvents() {
      let iframe = this.$refs.iframe;
      let iframeDoc = iframe.contentDocument;
      let iframeWindow = iframe.contentWindow;
      var self = this;
      let resizer = function () {
        let contentArea = iframeDoc.getElementsByClassName('dialog-off-canvas-main-canvas').item(0);
        if (!contentArea) {
          return;
        }
        var scormPlayer = iframeDoc.querySelector('[data-sco-id]');
        if (scormPlayer) {
          var width = scormPlayer.offsetWidth;
          if (self.saveData.custom_height_checkbox == 'custom' && self.saveData.custom_height != '') {
            scormPlayer.style.minHeight = parseInt(self.saveData.custom_height) + 'px';
          }
          else {
            scormPlayer.style.minHeight = parseInt(width/1.7777) + 'px';
          }
          if (scormPlayer.contentDocument) {
            self.ready = true;
          }
          scormPlayer.contentDocument.addEventListener('DOMContentLoaded', function() {
            self.ready = true;
          });
        }
        else {
          self.ready = true;
        }
        let height = contentArea.offsetHeight + 40;
        iframe.style.height = height + 'px';
      }
      iframeWindow.addEventListener('resize', function() {
        resizer();
      });
      resizer();
      // Initiate the API.
      let settings = iframeWindow.drupalSettings;
      if (settings) {
        if (settings.scormVersion && settings.scormVersion === '1.2') {
          var scormAPIobject = iframeWindow.API;
          if (scormAPIobject === undefined) {
            scormAPIobject = new iframeWindow.OpignoScorm12API(settings.scorm_data || {});
          }
        }
        else {
          var scormAPIobject = iframeWindow.API_1484_11;
          if (iframeWindow.API_1484_11 === undefined) {
            iframeWindow.API_1484_11 = new iframeWindow.OpignoScorm2004API(settings.scorm_data || {});
            scormAPIobject = iframeWindow.API_1484_11;
          }

          // Register scos suspend data.
          if (settings.opignoScormUIPlayer && settings.opignoScormUIPlayer.cmiSuspendItems) {
            iframeWindow.API_1484_11.registerSuspendItems(settings.opignoScormUIPlayer.cmiSuspendItems);
          }
        }
        var eventName = 'commit';
        if (settings.scormVersion === '1.2') {
          eventName = 'commit12';
        }
        let self = this;
        // Listen on commit event, and send the data to the server.
        scormAPIobject.bind(eventName, (value, data, scoId) => {
          self.updateScormResults(data);
        });

        var eventSetValueName = 'post-setvalue';
        if (settings.scormVersion === '1.2') {
          eventSetValueName = 'post-setvalue12';
        }
        // Listen on commit event, and send the data to the server.
        scormAPIobject.bind(eventSetValueName, (value, data, scoId) => {
          self.updateScormResults(scormAPIobject.data);
        });
      }

    }
  },
  watch: {
    active(val) {
      if (val == this.step && !this.iframeUrl) {
        this.init();
      }
      if (this.viewed === false && val == this.step) {
        this.viewed = true;
      }
      this.$emit("validation", this.valid);
    },
    valid(val) {
      if (val == true) {
        this.$emit("set-value", this.value);
      }
    }
  },
  components: {
    Spinner,
  }
};
</script>

<style>
.scorm-iframe-wrapper {
  min-height: 50px;
  position: relative;
}
.scorm-iframe-wrapper > .spinner-wrapper {
  background-color: transparent !important;
  position: absolute;
}
.scorm-iframe-wrapper .scorm-iframe {
  width: 100%;
}
</style>
